import React from 'react';
import image1 from '../../../../../images/modules/module-2/9.png';
import image2 from '../../../../../images/modules/module-2/10.png';
import image3 from '../../../../../images/modules/module-2/11.png';
import image4 from '../../../../../images/modules/module-2/12.png';
import image5 from '../../../../../images/modules/module-2/13.png';
import { generateRandomDate } from '../../../utils';
import { NewsCard } from '../NewsCard';
import './index.scss';

export const BannerContentMiddle = () => {
    return (
        <div className='runup-banner-middle-wrapper'>
            <div className='runup-banner-middle'>
                <img className='runup-banner-middle__image' src={image1} alt='banner' />
                <div className='runup-banner-middle__content'>
                    <div className='runup-banner-middle__title'>
                        Guide on How <br /> to Start Running
                    </div>
                    <div className='runup-banner-middle__date'>{generateRandomDate()}</div>
                </div>
            </div>
            <div className='runup-banner-middle__ads'>
                <div className='runup-banner-middle__ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image2}
                        text='Avoid These 5 Mistakes New Runners Make'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-banner-middle__ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image3}
                        text='How to Set (and Actually Hit) Running Goals That Stick'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-banner-middle__ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image4}
                        text='Yes, Joining a Run Group Can Boost Your Progress'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-banner-middle__ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image5}
                        text='Avoid These Common Setbacks as a New Runner'
                        date={generateRandomDate()}
                    />
                </div>
            </div>
        </div>
    );
};
